import { yupResolver } from '@hookform/resolvers/yup';
import { Form, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import PropTypes from 'prop-types';

import Flex from 'components/common/Flex';
import { FormProvider, RHFControl, RHFSelect } from 'components/common/form';
import LoadingButton from 'components/common/LoadingButton';
import { useEffect } from 'react';

const schema = Yup.object().shape({
  description: Yup.string().required('Required Field'),
  priority: Yup.string().required('Required Field')
});

function BeneficiaryFeedbackFormModal({
  show,
  onHide,
  isEdit,
  initialValues,
  onSubmit,
  loading
}) {
  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: initialValues ?? {
      description: '',
      priority: '',
      note_type: '',
      is_pinned: false
    },
    resolver: yupResolver(schema)
  });
  const { handleSubmit, watch, reset, register } = methods;
  const { description, priority } = watch();

  useEffect(() => {
    reset();
  }, [show, reset]);

  useEffect(() => {
    if (initialValues) {
      reset(initialValues);
    }
  }, [initialValues, reset]);

  const submitText = isEdit ? 'Save' : 'Create';

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Beneficiary Notes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Flex gap={3} direction="column" className="mt-3">
            <RHFControl
              name="description"
              placeholder="Note"
              rows={3}
              autoFocus
              as={'textarea'}
            />
            <RHFSelect
              name="note_type"
              label="Type"
              noOptional={true}
              isClearable={true}
              options={[
                { label: 'Phone call', value: 'Phone call' },
                { label: 'Email', value: 'Email' },
                { label: 'WhatsApp / Text', value: 'WhatsApp / Text' },
                { label: 'Meeting', value: 'Meeting' },
                { label: 'In person', value: 'In person' },
                { label: 'Letter', value: 'Letter' },
                { label: 'Payment', value: 'Payment' },
                { label: 'Sponsorship', value: 'Sponsorship' },
                { label: 'Gift Aid', value: 'Gift Aid' },
                { label: 'Complaint', value: 'Complaint' },
                { label: 'General', value: 'General' },
                { label: 'Other', value: 'Other' }
              ]}
            />
            <RHFSelect
              name="priority"
              placeholder="Priority"
              options={[
                { label: 'Important', value: 'Important' },
                { label: 'Fair', value: 'Fair' },
                { label: 'Ok', value: 'Ok' }
              ]}
            />

            {/* Pinned notes stay at the top of the Notes tab (#16) */}
            <Form.Check
              type="checkbox"
              id={'pin-note-beneficiary-notes'}
              label="Pin this note to the top"
              {...register('is_pinned')}
            />

            <LoadingButton
              type="submit"
              color="primary"
              className="w-100"
              disabled={!description || !priority}
              loading={loading}
            >
              {submitText}
            </LoadingButton>
          </Flex>
        </FormProvider>
      </Modal.Body>
    </Modal>
  );
}

BeneficiaryFeedbackFormModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default BeneficiaryFeedbackFormModal;
